<template>
  <div class="hr-yes-no-questions">
    <hr-chips
      :items="yesNoOptions"
      v-model:value="state.selected"
      :error-message="state.field?.fieldError"
      :masked="state.masked"
    >
      <div class="__title-container">
        <div v-if="title" class="__title">
          {{ title }}
          <sup class="__required-suffix">
            {{ suffix }}
          </sup>
        </div>
        <p v-html="helper" class="__helper"></p>
      </div>
    </hr-chips>
    <a v-if="!hasResponse && !state.hasComment" @click="addComment">{{
      t('hr-yes-no-question:add-comment')
    }}</a>
    <hr-co-input
      v-if="
        state.field?.questionValue?.responses[0]?.comment || state.hasComment
      "
      :value="state.field.questionValue?.responses[0]?.comment"
      :max="MAX_LENGTH"
      :masked="state.masked"
      @blur="(value) => updateComment(value)"
    >
    </hr-co-input>
  </div>
</template>
<script>
import HrChips from './hr-chips.vue';
import HrCoInput from './hr-co-input';
import { reactive, computed } from 'vue';
import t from '@/lib/i18next';
import { validateYesNoAnswer } from '../core/validation/common/custom-questions';
import { enableMask } from '@/core/fields-to-mask.js';

const MAX_LENGTH = 100;

export default {
  name: 'hr-yes-no-questions',
  components: { HrChips, HrCoInput },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:model-value'],
  setup(props, { emit }) {
    const state = reactive({
      field: computed(() => props.modelValue),
      selected: computed({
        get: () =>
          (state.field?.questionValue?.responses[0] || {}).answer || '',
        set: changeSelect,
      }),
      hasComment: false,
      masked: enableMask(props.modelValue),
    });
    const suffix = state.field?.questionValue?.isRequired ? '*' : '';
    const title = state.field?.questionValue?.question;
    const helper = state.field?.questionValue?.description;

    function convertQuestionResponseToChips(items) {
      return items?.map((item) => {
        return {
          id: item,
          description: item,
        };
      });
    }

    const yesNoOptions = convertQuestionResponseToChips(
      state.field?.questionValue?.options
    );

    const hasResponse =
      state.field.questionValue.responses.length !== 0
        ? state.field.questionValue.responses[0]?.comment
        : '';

    function getComment() {
      return (state.field?.questionValue?.responses[0] || {}).comment || '';
    }

    function getAnswer() {
      return (state.field?.questionValue?.responses[0] || {}).answer || '';
    }

    function changeSelect(value) {
      if (!state.field.questionValue?.responses) {
        return [];
      }
      state.field.questionValue.responses[0] = {
        answer: value,
        comment: getComment(),
      };
      state.field.value = state.field?.questionValue;
      validate();
      emit('update:model-value', state.field);
    }

    function addComment() {
      state.hasComment = true;
    }

    function updateComment(value) {
      state.field.questionValue.responses[0] = {
        answer: getAnswer(),
        comment: value?.trim(),
      };
      state.field.value = state.field?.questionValue;
      state.hasComment = true;
    }

    function validate() {
      state.field.fieldError = validateYesNoAnswer(state.field);
    }

    return {
      t,
      state,
      title,
      suffix,
      helper,
      yesNoOptions,
      hasResponse,
      convertQuestionResponseToChips,
      changeSelect,
      addComment,
      updateComment,
      MAX_LENGTH,
    };
  },
};
</script>
<style scoped>
.hr-yes-no-questions {
  margin-bottom: 32px;
}

a {
  color: var(--co-button-primary-fill);
}

a:hover {
  color: var(--co-button-primary-fill);
  cursor: pointer;
}

.__title {
  font-weight: 600;
  color: var(--co-text-primary);
  margin-bottom: 4px;
}

.__helper {
  font-size: 14px;
  color: var(--co-text-secondary);
  font-weight: 400;
}

.__required-suffix {
  font-weight: 600;
  left: -0.3em;
  color: var(--co-text-primary);
}

@media only screen and (max-width: 768px) {
  .hr-yes-no-questions,
  .__helper,
  :deep(.co-input__inner) {
    font-size: 16px;
  }
}
</style>
